













import Vue from 'vue';
import info from '!!raw-loader!@/assets/gitInfo.txt';
import DeploymentUtils, { Deployment } from '../../utils/DeploymentUtils';
export default Vue.extend({
  name: 'version-info',
  computed: {
    info() {
      return info;
    },
  },
  data(): {
    deployment?: Deployment;
  } {
    return {
      deployment: undefined,
    };
  },
  async mounted() {
    this.deployment = await DeploymentUtils.getDeploymentInfo();
  },
});
